/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
import './index.css';
import React from 'react';
import classNames from 'classname';
import Image from '../../lib/image';
import Button from '../../lib/button';

const Info = ({ img = '', name, price, inquiryPrice, selected, selectedList, supplierId }) => {
  let desc = '此价格为预估价格，以实际成交价为准。';
  if (selected) {
    desc = (supplierId === 1 && inquiryPrice < 50) ? '抱歉，机器无法估价，建议您留作纪念。' : '此价格为预估价格，以实际成交价为准。'
  }

  return <div className={classNames('mcycle-step-info', {
    step1: !selected,
    step2: selected
  })}>
    <Image src={img} className="mcycle-step-info-img" alt={name} />
    <a href="//mcycle.meizu.com/"><Button>重选机型</Button></a>
    <div className="mcycle-step-info-details">
      <h1 className="mcycle-step-info-name">{name}</h1>
      {supplierId === 1 && inquiryPrice < 50
        ? <p className="mcycle-step-info-expected" />
        : <p className="mcycle-step-info-expected">
          {selected ? '回收预估价' : '近期回收最高价'}
          <span className="mcycle-step-info-price">{selected ? inquiryPrice : price}</span>
        </p>
      }
      <p className="mcycle-step-info-desc">{desc}</p>
    </div>
    {selectedList
      ? <div className="mcycle-step-info-selected-wrap">
          <ul className="mcycle-step-info-selected">
            {selectedList.map((item, index) => (
              <li key={index} className="mcycle-step-info-item">{item}</li>
            ))}
          </ul>
        </div>
      : null
    }
  </div>
};

export default Info;



// WEBPACK FOOTER //
// ./src/components/step/info/index.js